export const GET_ACCOUNT_LIST = 'GET_ACCOUNT_LIST'
